<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center" style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb" style="height: 350px !important;">
        <div class="container text-center" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s" style="font-size: xx-large !important;">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">GENDER EQUALITY AND SOCIAL INCLUSION ACTION
                    PLAN</span>
                <span v-else>GENDER EQUALITY AND SOCIAL INCLUSION ACTION PLAN</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-warning">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">GESIAP</span>
                    <span v-else>GESIAP</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid bg-breadcrumbberanda wow fadeInDown">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                    MONITORING GENDER EQUALITY AND SOCIAL INCLUSION ACTION PLAN
                </h1>
                <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                    MONITORING GENDER EQUALITY AND SOCIAL INCLUSION ACTION PLAN
                </h1>
            </div>
        </div>
        <div class="container py-2">
            <div class="col-sm-12 text-center">
                <a class="hitam">
                    <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                        data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel3('_GESIAP_')">
                        <i class="fas fa-download"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Unduh Data .xlsx
                        </span>
                        <span v-else>
                            Download Data .xlsx
                        </span>
                    </button>
                </a>
            </div>
            <div class="col-sm-12 text-center">&nbsp;</div>
            <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldataprogres" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 600px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Rencana Aksi Gender
                                    </span>
                                    <span v-else>
                                        Gender Action Plan
                                    </span>
                                </th>
                                <th style="width: 200px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Kemajuan hingga saat ini
                                    </span>
                                    <span v-else>
                                        Progress to date
                                    </span>
                                </th>
                                <th style="width: 200px;">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Masalah dan Tantangan
                                    </span>
                                    <span v-else>
                                        Issues and Challenges
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td colspan="3" class="total">
                                        {{ datalist.Komponen }}
                                    </td>
                                </tr>
                                <template v-for="(datalist2, urutlist2) in datalist.DetailKomponen" :key="urutlist2">
                                    <tr>
                                        <td>
                                            <span class="text-danger">{{ datalist2.SubKomponen }}</span>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <template v-for="(datalist3, urutlist3) in datalist2.Detail" :key="urutlist3">
                                        <tr>
                                            <td>
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')"
                                                    class="text-success" v-html="datalist3.levelkomponen">
                                                </span>
                                                <span v-else class="text-success" v-html="datalist3.levelkomponen_eng">
                                                </span>
                                                <br><br>
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')" v-html="datalist3.level1">
                                                </span>
                                                <span v-else v-html="datalist3.level1_eng">
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                    {{ datalist3.kemajuan }}
                                                </span>
                                                <span v-else>
                                                    {{ datalist3.kemajuan_eng }}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                    {{ datalist3.keterangan }}
                                                </span>
                                                <span v-else>
                                                    {{ datalist3.keterangan_eng }}
                                                </span>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </template>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            sourcenya: '',
            datapesan: '',
            datamaster: [],
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        async G_tableCSVTabel3(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakgesiap-Data?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-GESIAP?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    this.colspan = Response.data.jumlahtahun;
                    this.datamaster = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.halamanloading = true;
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.datatahun = Response.data.tahun;
                        //alert(this.datatahun);

                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.datamaster = [];
                        this.datatahun = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster = [];
                this.datatahun = [];
                this.halamanloading = false;
            });


        },
    },
    mounted() {
        this.halamanloading = true;
        this.ambildata();
    },
}
</script>

<style></style>